// hide on viewport
// if ($(window).width() <= 960) {
//   $('#nav').attr('hidden', 'true');
// } else {
//   $('#nav').removeAttr('hidden');
// }

// $(window).on('resize', function () {
//   if ($(window).width() <= 960) {
//       $('#nav').attr('hidden', 'true');
//   } else {
//       $('#nav').removeAttr('hidden');
//   }
// });

// hide bootstrap notice from NeoCMS
$("[data-dismiss]").click(function () {
	$(this).parent().hide();
});

var langWrapper = document.querySelector('.language_wrapper');
var bialHamburger = document.querySelector('.hamburger');
var shopLink = document.querySelector('.e_shop_link');

bialHamburger.addEventListener('click', () => {
	if (!bialHamburger.classList.contains('is-active')) {
		langWrapper.style.display = "none"
		shopLink.style.display = "none"
	} else {
		langWrapper.style.display = "flex";
		shopLink.style.display = "flex";
	}
})

//animacja hamburgera
$(document).ready(function () {
	$(".hamburger").click(function () {
		$(this).toggleClass("is-active");
	});
});

//NAVBAR//change color and padding on scroll
var bialHeader = document.querySelector('.header__wrapper');

window.onscroll = function () {
	"use strict";
	const languagesColor = document.querySelector('.language_wrapper');
	if (!bialHamburger.classList.contains('is-active')) {
		if (document.body.scrollTop >= 120 || document.documentElement.scrollTop >= 20) {
			bialHeader.classList.add("nav_on_scroll");
			languagesColor.classList.add('toggle_black')

		} else {
			bialHeader.classList.remove("nav_on_scroll");
			languagesColor.classList.remove('toggle_black')
		}
	}

	const mainHeader = document.querySelector('.main_header')

	if($(mainHeader).length){
		if(mainHeader.classList.contains('nav_on_scroll')) {
			$('.nav_right_box').addClass('uk-animation-slide-right uk-animation-reverse');
		} else {
			$('.nav_right_box').removeClass('uk-animation-slide-right uk-animation-reverse');
		}
	}
};

(function () {
        var $domGoogle = $('.google-map'),
            map;
        if ($domGoogle) {
            if (!$domGoogle.attr('data-gmpa-key') || !$domGoogle.attr('data-gma-marker-pos'))
                return;
            window.initMap = function () {
                var startPos = $domGoogle.attr('data-gma-marker-pos').replace(' ', '').split(';'),
                    data = {
                        center: new google.maps.LatLng(startPos[0], startPos[1]),
                        zoom: 15,
                    };
                map = new google.maps.Map($domGoogle[0], {
                    center: data.center,
                    zoom: data.zoom,
                });
                new google.maps.Marker({
                    position: data.center,
                    map: map,
                    icon: {
                        url: data.marker,
                        scaledSize: new google.maps.Size(64, 64), //marker image size,
                        anchor: { x: 32, y: 32 },
                    }
                });
            };
            var $script = $('<script src="https://maps.googleapis.com/maps/api/js?key=' + $domGoogle.attr('data-gmpa-key') + '&callback=initMap"></script>');
            $script.insertBefore($('script').last());
        }
    })();


//contact subpage - columns heights on desktop
$( document ).ready(function() {
	if($('.contact_wrapper')) {

		var maxHeight = 0;

		if ($(window).width() >= 1270) {
			$(".height_comparison").each(function(){
				if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
			 });
			 $(".height_comparison").css("height", maxHeight);

		}

		$(window).on('resize', function () {
			if ($(window).width() >= 1270) {
				$(".height_comparison").each(function(){
					if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
				 });

				 $(".height_comparison").css("height", maxHeight);
			}
		});
	}
		//

	const detachInsert = function() {
		var element = $('.bottom_on_mobile').detach();
		if ($(window).width() <= 1201) {
			$('.insert_on_mobile').css("margin-top", "50px");
			$('.insert_on_mobile').append(element);
		} else {
			$('.insert_on_mobile').css("margin-top", "none");
			$('.insert_on_desktop').append(element);
		};

	}
	detachInsert();

	$(window).on('resize', function () {
		detachInsert();
	  });
});
